import { Accordion, AccordionDetails, AccordionSummary, ClickAwayListener, LinearProgress, Pagination, PaginationItem, Popper } from "@mui/material";
import { ArrowBack, Arrowdown2, Cancel, CardHolder, Documentupload, Forward , ServerSquareUpdate } from "../../../assets";
import { Button, CustomModal, Dropdown, EmptyTable, FilterInput, Input, Layout, TableRowResponsive, Textarea } from "../../components";
import { OffersListController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import moment from "moment-jalaali";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa";
import { planTypeList } from "../../../core/utils";
function CustomInput({ onFocus, value, onChange, title, emptyState }: any) {

  return (
    <>
      <Input customFocus={onFocus} myStyle="w-100" title={title} value={value} onChange={onChange} emptyState={emptyState} />
    </>
  )
}
class OffersList extends OffersListController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getList();
  }
  render() {
    const { 
      offersList, 
      from_date,
      title,
      to_date,
      number,
      national_code,
      first_name,
      last_name,
      fileUpload,
      uploadLoading,
      descr,
      uploadError,
      plan_type,
      loading
    } = this.state;
        return (
      <Layout title=" پیشنهاد بیمه نامه ">
        <Helmet>
          <title>  پیشنهاد بیمه نامه /  بیمه زندگی هامرز</title>
        </Helmet>
        {loading ?
          <LinearProgress />
          :
                <>
                <div className="policy-filter">
                <FilterInput hasFilter={[from_date, to_date, title, number, national_code, first_name, last_name , plan_type].every(item => item === "") ? false : true} resetFilter={() => this.resetFilter()} buttonTitle="فیلترها" placeholder="فیلتر" onClick={() => this.setState({ openModal: !this.state.openModal })} str={this.state.str} />
        </div>


        <div className="policy table-responsive scrollbar offers">
          <table className="table hide-mobile">
            <thead>
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">شماره پیشنهاد </th>
                <th scope="col">نوع پیشنهاد</th>
                <th scope="col">نام و نام خانوادگی بیمه گذار</th>

                <th scope="col">تاریخ شروع</th>
                <th scope="col">تاریخ پایان</th>
                <th scope="col">نام و نام خانوادگی بیمه شده</th>
                <th scope="col"> مدت دوره </th>
                <th scope="col"> مدت پرداخت </th>
                <th scope="col">عملیات</th>
              </tr>
            </thead>
            <tbody>

              {offersList?.list?.length > 0 && offersList?.list?.map((item: any, index: number) => {
                return (
                  <tr>
                    <th>{index + 1}</th>
                    <th>{item?.id}</th>
                    <td>{`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.plan_type)[0]?.title}`}</td>
                    <td>{`${item?.policy_holder_first_name} ${item?.policy_holder_last_name}`}</td>
                    <td>{moment(`${item?.start_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')}</td>
                    <td>{moment(`${item?.end_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')}</td>
                    <td>{`${item?.isured_first_name || ""} ${item?.isured_last_name || ""}`}</td>
                    <td>{item?.duration}</td>
                    <td>{item?.payment_duration}</td>
                    <td ><div className="d-flex align-items-center" >
                      <Button myStyle=" bg-green table-btn" title="آپلود مدارک" onClick={() => this.setState({ selecteditem: item, openUploadModal: true })} />
                      <Button myStyle=" bg-light-blue table-btn" title="ویرایش" link={`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.plan_type)[0]?.link}/${item?.id}`} />
                      <Button myStyle="bg-light-gray table-btn" title="جزئیات بیشتر" link={`/insurance-universal-offers/${item.id}`} />

                      {/* <span aria-describedby={this.id} onClick={this.handleClick} className="more">
                        <img src={More} alt="هامرز" />
                      </span> */}
                    </div>
                    </td>
                  </tr>
                )
              })}

            </tbody>

          </table>

          {offersList?.list?.length > 0 ? <>
            {offersList?.list?.map((item: any, index: number) => {

              return (
                <Accordion className="policy-accordion hide-desktop">
                  <AccordionSummary
                    expandIcon={<img src={Arrowdown2} alt="هامرز" />}
                    aria-controls="panel1a-content"
                    className="summsry"
                    id="panel1a-header"
                  >
                    <TableRowResponsive title="ردیف" value={index + 1} />
                    <TableRowResponsive title="شماره پیشنهاد" value={item?.id} />
                    <TableRowResponsive title="نوع پیشنهاد" value={`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.plan_type)[0]?.title}`} />

                  </AccordionSummary>
                  <AccordionDetails
                    className="d-flex flex-wrap"
                  >
                    <TableRowResponsive title="نام و نام خانوادگی بیمه گذار" value={`${item?.policy_holder_first_name} ${item?.policy_holder_last_name}`} />
                    <TableRowResponsive title="تاریخ شروع" value={moment(`${item?.start_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} />
                    <TableRowResponsive title="تاریخ پایان" value={moment(`${item?.end_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} />

                  </AccordionDetails>
                  <AccordionDetails
                    className="d-flex flex-wrap"
                  >

                    <TableRowResponsive title="نام و نام خانوادگی بیمه شده" value={`${item?.isured_first_name} ${item?.isured_last_name}`} />
                    <TableRowResponsive title="مدت دوره " value={item?.duration} />
                    <TableRowResponsive title="مدت پرداخت " value={item?.payment_duration} />
                  </AccordionDetails>
                  <AccordionDetails
                    className="d-flex flex-wrap"
                  >
                  <TableRowResponsive title="عملیات" value="" />
                    <div className="d-flex align-items-center" >
                      <Button myStyle="bg-light-blue table-btn" title="جزئیات بیشتر" link={`/insurance-universal-offers/${item.id}`} />
                                            <Button myStyle="bg-light-blue table-btn" title="آپلود مدارک" onClick={() => this.setState({ selecteditem: item, openUploadModal: true })}  />
                                            <Button myStyle=" bg-light-blue table-btn" title="ویرایش" link={`${planTypeList.filter((p: { value: string; }) => p.value ===  item?.plan_type)[0]?.link}/${item?.id}`} />

                    </div>
                  </AccordionDetails>


                </Accordion>
              )

            })
            }

            <Pagination
              className="custom-pagination"
              count={offersList?.total ? Math.ceil(offersList?.total / 10) : 1}
               page={offersList?.page_number}
              onChange={this.handleChangePage}
              size="small"
              renderItem={(item) => (
                <PaginationItem
                  slots={{ previous: Forward, next: ArrowBack }}
                  {...item}
                />
              )}
            />
          </>

            : <EmptyTable title="   پیشنهادی ثبت نشده است " />
          }
          {this.state.open &&
            <div className="backdrop" onClick={() => this.setState({ open: !this.state.open })}>
              <ClickAwayListener onClickAway={() => this.setState({ open: false })}>


                <Popper placement="right" id={this.id} open={this.state.open} anchorEl={this.state.anchorEl}
                  className="policy-popover"
                  disablePortal={false}
                  modifiers={[
                    {
                      name: 'flip',
                      enabled: true,
                      options: {
                        altBoundary: true,
                        rootBoundary: 'document',
                        padding: 8,
                      },
                    },
                    {
                      name: 'preventOverflow',
                      enabled: false,
                      options: {
                        altAxis: false,
                        altBoundary: true,
                        tether: true,
                        rootBoundary: 'document',
                        padding: 8,
                      },
                    },
                    {
                      name: 'arrow',
                      enabled: true,
                      options:
                        <div> 5 </div>,

                    },
                  ]}
                >

                  <div className="policy-popover-content ">
                    <span className="ancher"></span>
                    <div className="policy-popover-content-item" > <img src={ServerSquareUpdate} alt="هامرز" /><span>
                      جزئیات بیشتر
                    </span></div>
                    <div className="policy-popover-content-item" onClick={() => this.setState({ openUploadModal: true })}> <img src={CardHolder} alt="هامرز" /> <span>
                      آپلود مدارک
                    </span>  </div>

                  </div>
                </Popper >
              </ClickAwayListener>
            </div>
          }
        </div>
        <CustomModal openModal={this.state.openModal} onClose={() => this.setState({ openModal: !this.state.openModal })}>
          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
                فیلتر های کارمزد ها
              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                  فیلتر های بیمه نامه :
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            
            <h2 className="custom-modal-title mt-33">
              بر اساس اطلاعات پیشنهاد
            </h2>
            <div className="custom-modal-row ">
              <Input myStyle="custom-modal-item" title="شماره پیشنهاد" value={number} onChange={(e: any) => this.setState({ number: e })} emptyState={() => this.setState({ number: "" })} />
              <DatePicker
                ref={this.datePickerRef}
                render={<CustomInput
                  title="از تاریخ"

                  emptyState={() => this.setState({ from_date: "" })} />}
                value={from_date}
                dateSeparator=" تا "
                calendar={persian}
                locale={persian_fa}
                placeholder=" از تاریخ "
                containerClassName="custom-modal-item filter-date-container"
                inputClass="custom-date-input"
                calendarPosition="top-right"
                onChange={this.handleChangeFromDate}
                maxDate={new DateObject({
                  calendar: persian,
                })}

              />
              <DatePicker
                ref={this.datePickerRef}
                render={<CustomInput
                  title="تا تاریخ"
                  emptyState={() => this.setState({ to_date: "" })} />}
                dateSeparator=" تا "
                calendar={persian}
                locale={persian_fa}
                value={to_date}
                placeholder="تا تاریخ"
                containerClassName="custom-modal-item filter-date-container"
                inputClass="custom-date-input"
                calendarPosition="top-right"
                onChange={this.handleChangeToDate}
                maxDate={new DateObject({
                  calendar: persian,
                })}

              />
            </div>
            <div className="custom-modal-row ">
            <Dropdown myStyle="custom-modal-item" objectList items={planTypeList } title="نوع پیشنهاد" value={plan_type} onChange={(e: any) => this.setState({ plan_type: e.target.value })} /> 
            </div>

            <div className="custom-modal-confirm">
              <Button myStyle="bg-green" title="اعمال" onClick={() => this.getList()} />
            </div>
          </>
        </CustomModal>



        <CustomModal myStyle="offers-upload-modal" openModal={this.state.openUploadModal} onClose={() => this.closeUploadModal()}>
          <>
            <div className="custom-modal-main-title mb-3 ">
              <h1 className="title">
                آپلود مدارک              </h1>
              <Cancel myStyle="hide-desktop ps-2 " width="20" height="20" color="#000000" onClick={() => this.closeUploadModal()} />
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.closeUploadModal()} />
            </div>
            <div className="offers-upload">
              <div className="uploader-container ">

                {this.state.file ?
                  <div className="file-container">

                    <span className="file-name">{fileUpload?.name}</span>
                    <Button myStyle="remove" title="حذف" onClick={() => this.setState({ fileUpload: "", file: "" })} />

                  </div>
                  :
                  <>
                    <span className="title">
                      جهت آپلود مدارک از طریق

                      <span className="bold title">  بارگذاری مدارک </span>
                      <br />

                      خود را آپلود نمایید.                              </span></>


                }
                <div className="img-container">


                  <div className="file-upload">
                    <div className="file-upload-btn">
                      <label className="file-upload-lable" htmlFor="file-input">

                        <img src={Documentupload}  className="cursor-pointer" alt="هامرز" />
                      </label>
                      <input
                        accept="image/*,.pdf,.excel"
                        type="file"
                        hidden
                        id="file-input"
                        onChange={(event) => this.uploadImage(event)}
                      />
                    </div>

                    <h5 className="file-upload-text"> بارگذاری فایل</h5>
                  </div>
                </div>
                <div className="error-text w-100">
                  {uploadError.filter((name: { path: string; }) => name.path === `fileUpload`)?.[0]?.errors?.[0]}
                </div>
                <Textarea error={uploadError.filter((name: { path: string; }) => name.path === `descr`)?.[0]?.errors?.[0]} myStyle="description mt-3" placeholder="توضیحات" value={descr} onChange={(e: any) => this.setState({ descr: e.target.value })} />

              </div>
              <div className="d-flex">
                <Button loading={uploadLoading} myStyle="bg-light-blue table-btn upload-btn" title="تایید و آپلود " onClick={() => this.uploadFile()} />
                <Button loading={uploadLoading} myStyle="bg-light-gray table-btn upload-btn" title="برگشت" onClick={() => this.closeUploadModal()} />
              </div>
            </div>
          </>
        </CustomModal>
                </>
                }
      </Layout>
    )
  }
}
export default OffersList;